<div class="edit-amount-dialog">
  <header class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>payments</mat-icon>
    </div>
    <div class="dialog-header__text">
      <span class="dialog-header__eyebrow">Servicios</span>
      <h2 mat-dialog-title>Editar monto</h2>
      <p class="dialog-header__subtitle">
        Actualiza el total del servicio antes de generar la orden.
      </p>
      <p *ngIf="serviceName" class="dialog-header__context">
        {{ serviceName }}
      </p>
    </div>
  </header>

  <mat-dialog-content class="dialog-body">
    <div class="meta-row">
      <div class="meta-stat">
        <span class="meta-stat__label">Moneda</span>
        <strong class="meta-stat__value">{{ currencyLabel }}</strong>
      </div>
      <div class="meta-stat" *ngIf="tipoCambio != null; else missingFx">
        <span class="meta-stat__label">Tipo de cambio</span>
        <strong class="meta-stat__value">{{ tipoCambio }}</strong>
      </div>
      <ng-template #missingFx>
        <div class="meta-stat meta-stat--warn">
          <span class="meta-stat__label">Tipo de cambio</span>
          <strong class="meta-stat__value">Sin TC</strong>
        </div>
      </ng-template>
      <div class="meta-stat" *ngIf="currentTotalLabel">
        <span class="meta-stat__label">Actual</span>
        <strong class="meta-stat__value">{{ currentTotalLabel }}</strong>
      </div>
    </div>

    <div *ngIf="saveError" class="alert alert--error" role="alert">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong>No se pudo guardar</strong>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="field-group">
      <div class="field-group__header">
        <label class="field-group__label" for="edit-service-amount">
          Nuevo monto
        </label>
        <span class="field-badge field-badge--required">Obligatorio</span>
      </div>

      <div
        class="amount-field"
        [class.amount-field--error]="showNegativeError || !!amountError"
        [class.amount-field--disabled]="loading"
      >
        <span class="amount-field__prefix" aria-hidden="true">{{
          currencyPrefix
        }}</span>
        <input
          id="edit-service-amount"
          type="number"
          min="0"
          step="0.01"
          inputmode="decimal"
          [ngModel]="amount"
          (input)="onMontoInput($event)"
          (wheel)="onWheelPrevent($event)"
          class="amount-field__input"
          [disabled]="loading"
          placeholder="0.00"
          autocomplete="off"
        />
      </div>

      <p class="field-group__hint">
        El backend convierte con el tipo de cambio del servicio. No se puede
        editar si ya tiene OS o NP.
      </p>
      <p *ngIf="showNegativeError" class="field-group__error">
        El monto no puede ser negativo.
      </p>
      <p *ngIf="amountError" class="field-group__error">{{ amountError }}</p>
    </div>

    <div class="scope-block" *ngIf="allowGrouped">
      <p class="scope-block__label">Aplicar cambio a</p>
      <div class="scope-options" role="radiogroup" aria-label="Alcance de edición">
        <button
          type="button"
          class="scope-card"
          [class.scope-card--active]="scope === 'SINGLE'"
          [disabled]="loading"
          (click)="scope = 'SINGLE'"
        >
          <span class="scope-card__title">Solo este</span>
          <span class="scope-card__desc">Actualiza únicamente este servicio.</span>
        </button>
        <button
          type="button"
          class="scope-card"
          [class.scope-card--active]="scope === 'GROUPED'"
          [disabled]="loading"
          (click)="scope = 'GROUPED'"
        >
          <span class="scope-card__title">Agrupados</span>
          <span class="scope-card__desc"
            >Mismo monto en personal de campo / guía sin OS.</span
          >
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      mat-stroked-button
      type="button"
      class="btn btn--ghost"
      (click)="onCancel()"
      [disabled]="loading"
    >
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="btn btn--primary"
      (click)="saveMonto()"
      [disabled]="!canSubmit"
    >
      <mat-progress-spinner
        *ngIf="loading"
        mode="indeterminate"
        diameter="18"
      ></mat-progress-spinner>
      <span *ngIf="!loading">Guardar monto</span>
    </button>
  </mat-dialog-actions>
</div>
